// tslint:disable-next-line:no-var-requires
const _ = require('lodash');

import { Vas } from '@/data/vas/vas';

import config from '../../config/vas.json';

export class VasConfig {
  public readonly list: Vas[];

  constructor() {
    this.list = _.reduce(
      config.vas,
      (z: Vas[], categoryData: any, categoryId: string) => {
        _.forEach(categoryData.plan, (vasData: any, vasId: string) => {
          z.push(
            new Vas(
              vasId,
              vasData,
              categoryId,
              categoryData.name,
              categoryData.init_charge
            )
          );
        });
        return z;
      },
      []
    );
  }
  public vasCategoryId(): string[] {
    return _.uniq(_.map(this.list, (vas: Vas) => vas.categoryId));
  }

  public findVasIdsBy(categoryId: string): string[] {
    const list: string[] = _.map(this.list, (vas: Vas) => {
      return vas.categoryId === categoryId ? vas.id : null;
    });
    return _.compact(list);
  }

  public getVas(id: string): Vas {
    return _.find(this.list, (item: Vas) => {
      return item.id === id;
    });
  }
}
